import { Component, ElementRef, ViewChild, inject, input, output } from '@angular/core';
import { GeneralService } from '@shared/services/general.service';
import Athena from 'athena-player';
import { AthenaProps } from 'athena-player/core/playerTypes';

@Component({
  selector: 'app-ghost-player',
  templateUrl: './ghost-player.component.html',
  styleUrls: ['./ghost-player.component.scss'],
})
export class GhostPlayerComponent {
  @ViewChild('playerContainer') playerContainer!: ElementRef<HTMLDivElement>;
  Autoplay = input(true);
  IsTopQuality = input(false);
  EndedVideo = output<boolean>();
  IsMuted = output<boolean>();
  athenaPlayer: Athena | null = null;

  private readonly generalService = inject(GeneralService);

  initialPlayer(link: string) {
    if (this.athenaPlayer) return;
    if (!this.generalService.isBrowserOnly) return;
    const configs: AthenaProps = {
      hlsFilePath: link,
      ref: this.playerContainer.nativeElement,
      hideController: true,
      viewable: true,
      maxBufferLength: 30,
      viewType: 'cover',
      autoPlay: this.Autoplay(),
      onEnd: () => {
        this.EndedVideo.emit(true);
      },
      onFirstPlay: () => {
        if (this.athenaPlayer) {
          this.IsMuted.emit(this.athenaPlayer.isMuted());
        }
      },
    };
    if (!this.IsTopQuality) {
      configs.initialQuality = 360;
    }
    this.athenaPlayer = new Athena(configs);
    this.athenaPlayer!.loadPlayer();
  }

  destroy() {
    this.athenaPlayer?.destroy();
    this.athenaPlayer = null;
  }
}
